<match-display-wrapper
    matchLabel="{{ globalL10nKeys.protocolLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
>
    {{ matchValueDescription }}
</match-display-wrapper>
